/**
 * Remove the `index.html` extension from a location string. This allows
 * matching on both pretty and non pretty urls against the same route.
 *
 * @param location - The location string to remove from
 * @returns - The location string without the extension
 */
export function removeIndexHtmlExtension(location: string) {
  return location
    .split('/')
    .filter(part => part !== 'index.html')
    .join('/');
}
